import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';

import { DateRange } from '@mui/lab';
import moment from 'moment';
import { Card, Grid, Stack, Typography } from '@mui/material';
import SelectFieldFormHook from 'src/components/Forms/Select';
import { useFetchDataOptions } from 'src/hooks/Commons/useFetchDataOption';
import { TOption, TRequestOption } from 'src/types/Commons/option.model';
import { OptionType } from 'src/utils/enums/option';
import ButtonColor from 'src/components/Forms/Buttons';
import { isPermissionFuntion } from 'src/utils/commons/permission';
import { FunctionEnum, PageRouteEnum } from 'src/utils/enums/permissionType';
import useUserProfile from 'src/hooks/Users/useUserProfile';
import DateRangePickerFormHook from 'src/components/Forms/DateRange';
import { isAdmin } from 'src/utils/commons/checkRole';
import TextFieldFormHook from 'src/components/Forms/Inputs';
import CheckBoxFormHook from 'src/components/Forms/Checkboxes';
import { TSalesReportRequest } from 'src/types/Reports/salesReport.model';
import { listDeliveryStatus } from 'src/utils/options/listOption';

type FindManagerProps = {
  isLoading?: boolean;
  onFindReport: (data: any) => void;
  title: string;
};

function PageHeader({ onFindReport, isLoading, title }: FindManagerProps) {
  const { profile } = useUserProfile();
  const [valueBetweenDate, setValueBetweenDate] = useState<DateRange<Date>>([
    moment().startOf('month').toDate(),
    moment().endOf('month').toDate()
  ]);

  const searchPMParams: TRequestOption = {
    type: OptionType.ProjectManager,
    take: 10
  };
  const { data: listPM } = useFetchDataOptions(searchPMParams);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors }
  } = useForm<TSalesReportRequest>({
    mode: 'onSubmit',
    defaultValues: {
      startDate: moment().startOf('month').format('yyyy-M-d'),
      endDate: moment().endOf('month').format(),
      userId: 0,
      excludeShipmentFee: false,
      orderStatusViewType: 0
    }
  });

  const onSubmit = async (data: any) => {
    const converts: TSalesReportRequest = {
      userId: data.userId,
      startDate: moment(valueBetweenDate[0]).format(),
      endDate: valueBetweenDate[1] ? moment(valueBetweenDate[1]).endOf('date').format() : '',
      page: 1,
      take: 10,
      searchText: data.searchText,
      isViewTeam: data.isViewTeam,
      orderStatusViewType: data.orderStatusViewType,
      excludeShipmentFee: data.excludeShipmentFee,
      t: new Date().getTime()
    };

    onFindReport && onFindReport(converts);
  };

  const handleChangeBetweenDate = (arrValue: any) => {
    setValueBetweenDate(arrValue);
  };
  useEffect(() => {
    // handleSubmit(onSubmit)();
  }, []);
  const _listPM = [{ label: 'Tất cả', value: '-1' } as TOption].concat(listPM?.data ?? []);
  return (
    <Card className="p-8">
      <Typography sx={{ pb: 3 }} variant="h4">
        {title}
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)} className="form">
        <Grid container spacing={2}>
          {isAdmin(profile.roleFId) && (
            <Grid item xs={12} md={3}>
              <SelectFieldFormHook
                register={register}
                id="userId"
                name="userId"
                label="Lọc theo PM"
                variant="outlined"
                dataOptions={_listPM}
                value={watch('userId')}
                setValue={setValue}
                // defaultValue={`${listPM?.data[0]?.value ?? 0}`}
              />
            </Grid>
          )}
          <Grid item xs={12} md={3}>
            <TextFieldFormHook
              register={register}
              id="searchText"
              name="searchText"
              label="Nhập tên/ Id Pushsale"
              variant="outlined"
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <DateRangePickerFormHook
              register={register}
              value={valueBetweenDate}
              startText="Từ ngày"
              endText="Đến ngày"
              idStart="startDate"
              idEnd="endDate"
              inputFormat="dd/MM/yyyy"
              format="MM/dd/yyyy"
              onChangeDate={handleChangeBetweenDate}
              errorMessageStartDate={errors?.startDate?.message}
              errorMessageEndDate={errors?.endDate?.message}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectFieldFormHook
              register={register}
              id="orderStatusViewType"
              name="orderStatusViewType"
              label="Trạng thái giao hàng"
              variant="outlined"
              dataOptions={listDeliveryStatus}
              value={watch('orderStatusViewType')}
              setValue={setValue}
              // defaultValue={`${listPM?.data[0]?.value ?? 0}`}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Stack direction="row" spacing={2} className="h-24 self-center">
              <CheckBoxFormHook register={register} name="isViewTeam" label="Xem doanh số team" onChange={() => {}} />
            </Stack>
          </Grid>
          <Grid item xs={12} md={3}>
            <Stack direction="row" spacing={2} className="h-24 self-center">
              <CheckBoxFormHook
                register={register}
                name="excludeShipmentFee"
                label="Trừ phí vận chuyển"
                onChange={() => {}}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} md={12} className="flex justify-end">
            {isPermissionFuntion(PageRouteEnum.SALE_REPORT, FunctionEnum.SEARCH, profile) && (
              <Stack direction="row" spacing={2} className="h-24 self-right">
                <ButtonColor
                  isFetchingData={isLoading}
                  type="submit"
                  className="px-16"
                  color="success"
                  btnTitle="Xem"
                />
              </Stack>
            )}
          </Grid>
        </Grid>
      </form>
    </Card>
  );
}

export default PageHeader;
